import React, { MouseEventHandler, useEffect, useState } from "react"
import { Alert, Button, Modal, Row, Tab, Tabs } from "react-bootstrap"
import { CheckCircle, XCircle } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import { pricing } from "../../api"
import ConfirmModal from "../../components/Common/ConfirmModal"
import PersonalInfoTab from "./UpdateCustomerModalTabs/PersonalInfoTab"
import ShippingRatesTab from "./UpdateCustomerModalTabs/ShippingRatesTab"
import ValueAddedServicesTab from "./UpdateCustomerModalTabs/ValueAddedServicesTab"
import WalletDetailsTab from "./UpdateCustomerModalTabs/WalletDetailsTab"

const CustomerUpdateModal = ({
    show,
    customer,
    handleClose,
    message,
    error,
    errors,
    setMessage,
    setError,
    setErrors,
    handleSubmit,
    warehouses,
    shippingServices,
    setShippingServices,
    setUpdateModalWarehouse,
    requestsLoader,
    requestSuccess,
    // rateSlabs,
    handleDeletingShippingRate,
    handleDeletingVAS,
    setRequestSuccess
}: {
    show: string
    customer: Record<string, any>
    handleClose: () => void
    message: string
    error: string
    errors: string[]
    setMessage: Function
    setError: Function
    setErrors: Function
    handleSubmit: Function
    warehouses: Record<string, any>[]
    shippingServices: Record<string, any>[]
    setShippingServices: Function
    setUpdateModalWarehouse: Function
    requestsLoader: boolean
    requestSuccess: boolean
    // rateSlabs: Record<string, any>[]
    handleDeletingShippingRate: Function
    handleDeletingVAS: Function
    setRequestSuccess: Function
}) => {
    const { t, i18n } = useTranslation()
    const [tab, setTab] = useState("personal-info")
    const [updatedCustomerData, setUpdatedCustomerData] = useState({} as Record<string, any>)
    const [variationData, setVariationData] = useState({} as Record<string, any>)
    const [customerShippingRates, setCustomerShippingRates] = useState([] as Record<string, any>[])
    const [customerValueAddedServices, setCustomerValueAddedServices] = useState([] as Record<string, any>[])
    const [selectedWarehouse, setSelectedWarehouse] = useState({} as Record<string, any>)
    const [loading, setLoading] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState("")
    const [incomingOrderFeature, setIncomingOrderFeature] = useState(0)
    const [uploadFiles, setUploadFiles] = useState(0)
    const [fullfilmentFeature, setFullfilmentFeature] = useState(0)
    const [template, setTemplate] = useState(0)

    //TODO: move rate slabs to parent

    const getCustomerShippingRates = async () => {
        try {
            const res = await pricing.listShippingRates(customer?.id)
            if (res?.data?.status) {
                setCustomerShippingRates([...res?.data?.payload])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getCustomerValueAddedServices = async () => {
        try {
            const res = await pricing.listCustomerValueAddedServices(customer?.id)
            if (res?.data?.status) {
                setCustomerValueAddedServices([...res?.data?.payload])
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (customer?.id || requestSuccess) {
            setLoading(true)
            getCustomerShippingRates()
            getCustomerValueAddedServices()
            setRequestSuccess(false)
            setLoading(false)
        }
    }, [customer?.id, requestSuccess, tab])

    useEffect(() => {
        setIncomingOrderFeature(customer?.show_incoming_orders)
        setFullfilmentFeature(customer?.show_fullfilment)
        setUpdatedCustomerData({ ...customer, plan_expiry: customer?.PlanTransaction?.expiry_at })
    }, [customer?.id])

    const handleChange = (e: any) => {
        if (e.target.name === "active" || e.target.name === "credited") {
            const propName = e.target.name === "credited" ? "is_credit_user" : "status"
            if (e.target.checked) {
                setUpdatedCustomerData({ ...updatedCustomerData, [propName]: 1 })
            }
        }
        if (e.target.name === "inactive" || e.target.name === "noncredited") {
            const propName = e.target.name === "noncredited" ? "is_credit_user" : "status"
            if (e.target.checked) {
                setUpdatedCustomerData({ ...updatedCustomerData, [propName]: 0 })
            }
        }

        if (e.target.checked) {
            if (e.target.name === "showIncomingOrders") {
                setIncomingOrderFeature(1)
                setUpdatedCustomerData({ ...updatedCustomerData, show_incoming_orders: 1 })
            }
            if (e.target.name === "showFullfilment") {
                setFullfilmentFeature(1)
                setUpdatedCustomerData({ ...updatedCustomerData, show_fullfilment: 1 })
            }
            if (e.target.name === "notShowIncomingOrders") {
                setIncomingOrderFeature(0)
                setUpdatedCustomerData({ ...updatedCustomerData, show_incoming_orders: 0 })
            }
            if (e.target.name === "notShowFullfilment") {
                setFullfilmentFeature(0)
                setUpdatedCustomerData({ ...updatedCustomerData, show_fullfilment: 0 })
            }
            if (e.target.name === "uploadFiles") {
                setUploadFiles(1)
                setUpdatedCustomerData({ ...updatedCustomerData, upload_files: 1 })
            }
            if (e.target.name === "notUploadFiles") {
                setUploadFiles(0)
                setUpdatedCustomerData({ ...updatedCustomerData, upload_files: 0 })
            }
            if (e.target.name === "template_amazon") {
                setTemplate(1)
                setUpdatedCustomerData({ ...updatedCustomerData, template: 1 })
            }
            if (e.target.name === "template_amazon_wo_lm") {
                setTemplate(4)
                setUpdatedCustomerData({ ...updatedCustomerData, template: 4 })
            }
            if (e.target.name === "template_noon") {
                setTemplate(2)
                setUpdatedCustomerData({ ...updatedCustomerData, template: 2 })
            }
        }
        if (e.target.name === "end_date") {
            setUpdatedCustomerData({ ...updatedCustomerData, plan_expiry: e.target.value })
        } else {
            setUpdatedCustomerData({ ...updatedCustomerData, [e.target.name]: e.target.value })
        }
    }

    return (
        <Modal
            size={"xl"}
            id="customer-update"
            show={show === "customerUpdateModal"}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton />
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                {message && message !== "" && (
                    <Alert
                        className="d-flex align-items-center my-2"
                        onClose={() => setMessage("")}
                        dismissible
                        variant="success">
                        <CheckCircle className="text-success" /> &nbsp;&nbsp; {t(message)}
                    </Alert>
                )}
                {error && error !== "" && (
                    <Alert
                        className="d-flex align-items-center  my-2"
                        onClose={() => setError("")}
                        dismissible
                        variant="danger">
                        <XCircle className="text-danger" /> &nbsp;&nbsp; {t(error)}
                    </Alert>
                )}
                {errors &&
                    errors?.length > 0 &&
                    errors?.map((e) => (
                        <Alert
                            className="d-flex align-items-center  my-2"
                            onClose={() => setErrors([])}
                            dismissible
                            variant="danger">
                            <XCircle className="text-danger" /> &nbsp;&nbsp; {t(e)}
                        </Alert>
                    ))}
                <Modal.Title>
                    {`${customer?.fname} ${customer?.lname}`} {t(" / Edit Account")}
                </Modal.Title>
                <Row className="mt-4 mx-1 d-flex tabs-data">
                    <Tabs
                        id="customer-tab"
                        activeKey={tab}
                        onSelect={(k: any) => {
                            setVariationData({})
                            setTab(k)
                            setSelectedWarehouse({})
                            setUpdateModalWarehouse(0)
                        }}
                        className="mb-3">
                        <Tab
                            eventKey="personal-info"
                            className="text-start overflow-x-hidden"
                            title={t("Personal & Shipping information")}>
                            <PersonalInfoTab handleChange={handleChange} customer={updatedCustomerData} />
                        </Tab>
                        <Tab
                            eventKey="shipping-rates"
                            className="text-start overflow-x-hidden pb-3 bg-light-grey"
                            title={t("Shipping Discounts")}>
                            <ShippingRatesTab
                                customerShippingRates={customerShippingRates}
                                warehouses={warehouses}
                                // rateSlabs={rateSlabs}
                                customer={updatedCustomerData}
                                shippingServices={shippingServices}
                                setUpdateModalWarehouse={setUpdateModalWarehouse}
                                variationData={variationData}
                                setVariationData={setVariationData}
                                loading={loading}
                                requestsLoader={requestsLoader}
                                selectedWarehouse={selectedWarehouse}
                                setSelectedWarehouse={setSelectedWarehouse}
                                setShippingServices={setShippingServices}
                                handleSubmit={handleSubmit}
                                showConfirmModal={showConfirmModal}
                                setShowConfirmModal={setShowConfirmModal}
                            />
                        </Tab>
                        <Tab
                            eventKey="services"
                            className="text-start overflow-x-hidden pb-3 bg-light-grey"
                            title={t("VAS Discounts")}>
                            <ValueAddedServicesTab
                                customerValueAddedServices={customerValueAddedServices}
                                warehouses={warehouses}
                                customer={customer}
                                setUpdateModalWarehouse={setUpdateModalWarehouse}
                                variationData={variationData}
                                setVariationData={setVariationData}
                                loading={loading}
                                requestsLoader={requestsLoader}
                                selectedWarehouse={selectedWarehouse}
                                setSelectedWarehouse={setSelectedWarehouse}
                                handleSubmit={handleSubmit}
                                showConfirmModal={showConfirmModal}
                                setShowConfirmModal={setShowConfirmModal}
                            />
                        </Tab>
                        <Tab
                            eventKey="wallet"
                            className="text-start overflow-x-hidden pb-3 bg-light-grey"
                            title={t("Wallet")}>
                            <WalletDetailsTab customer={customer} />
                        </Tab>
                    </Tabs>
                </Row>
            </Modal.Body>
            {tab === "personal-info" && (
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                        {t("Cancel")}
                    </Button>

                    <Button
                        onClick={() => {
                            handleSubmit(
                                updatedCustomerData,
                                "personal-info",
                                incomingOrderFeature,
                                fullfilmentFeature,
                                template,
                                uploadFiles
                            )
                        }}
                        className="btn btn-primary"
                        type="submit">
                        {t("Save")}
                    </Button>
                </Modal.Footer>
            )}
            <ConfirmModal
                show={showConfirmModal && showConfirmModal !== "" ? "deleteConfirmModal" : ""}
                data={variationData?.id || null}
                handleClose={() => {
                    setVariationData({})
                    setShowConfirmModal("")
                    setSelectedWarehouse({})
                    setUpdateModalWarehouse(0)
                }}
                handleSubmit={(id?: number) => {
                    if (id) {
                        if (showConfirmModal === "deleteShippingDiscount") {
                            handleDeletingShippingRate(id)
                        } else {
                            handleDeletingVAS(variationData?.id)
                        }
                    }
                    setShowConfirmModal("")
                    setVariationData({})
                    setSelectedWarehouse({})
                    setUpdateModalWarehouse(0)
                }}
                title={`Delete ${showConfirmModal === "deleteShippingDiscount" ? "Shipping" : "VAS"} Discount`}
            />
        </Modal>
    )
}

export default CustomerUpdateModal
